<template>
  <div>
    <div class="search-header d-flex justify-content-between align-items-center mb-3">
      <b-nav pills>
        <b-nav-item :active="filter.status === null" @click="filter.status = null">{{ $t('all') }}({{properties.data.length}})</b-nav-item>
        <b-nav-item :active="filter.status === 'published'" @click="filter.status = 'published'">{{ $t('published') }}({{publishedCount.length}})</b-nav-item>
        <b-nav-item :active="filter.status === 'draft'" @click="filter.status = 'draft'">{{ $t('draft') }}({{draftCount.length}})</b-nav-item>
      </b-nav>
      <div class="search-bar">
        <b-nav-form class="d-flex">
          <b-form-input :placeholder="$t('label_search-property')" class="py-2 mr-1" type="search" v-model="filter.name"></b-form-input>
          <b-button class="search-btn px-4 ml-n2" variant="secondary" type="button">
            <b-icon icon="search" scale="1"></b-icon>
          </b-button>
        </b-nav-form>
      </div>
    </div>
    <div class="responsive-table">
      <b-table id="my-table"
        head-variant="light"
        bordered
        responsive
        hover
        thead-tr-class="text-center"
        tbody-tr-class="text-center"
        :items="filteredProperty"
        :per-page="perPage"
        :current-page="currentPage"
        :fields="fields"
        @row-selected="onRowSelected"
      >
        <template #cell(property)="row">
          <div class="d-flex justify-content-center">
            <b-button variant="dark" class="mx-1" :style="{visibility: row.value.some(i => i.property_video.length !== 0) ? 'visible': 'hidden'}">M</b-button>
            <b-button variant="dark" class="mx-1" :style="{visibility: row.value.some(i => i.chatbot_url !== null && i.chatbot_url !== '') ? 'visible' : 'hidden'}">A</b-button>
          </div>
        </template>
        <template #head(property_types)="">
          <label class="p-2 m-0 mr-1 bg-dark text-white">{{ $t('label_publish-ok') }}</label>
          <label class="p-2 m-0 bg-secondary text-white">{{ $t('label_editting') }}</label>
        </template>
        <template #cell(property_types)="row">
          <div class="d-flex justify-content-center">
            <router-link :to="locationDescriptor(row.item.id, `name_${lang}`)" v-for="lang in ['ja', 'en', 'zh-cn', 'zh-tw']" :key="lang">
              <b-button
                class="mx-1"
                :variant="row.value[`name_${lang}`] === 'published' ? 'dark' : 'secondary'"
                :style="{visibility: row.value[`name_${lang}`] && row.value[`name_${lang}`] !== '' ? 'visible' : 'hidden'}"
              >{{ $t(`label_${lang}`) }}</b-button>
            </router-link>
          </div>
        </template>
        <template #cell(administrative_title)="row">
          <router-link class="text-dark" :to="locationDescriptor(row.item.id, 'name_ja')"> {{ row.value }}</router-link>
        </template>
        <template #cell(property_category)="row">
          {{ $t(row.value) }}
        </template>
      </b-table>
    </div>
    <div>
      <div class="m-4">
        <b-pagination align="center" size="lg" class="position-relative"
          v-model="currentPage"
          :total-rows="filteredProperty.length"
          :per-page="perPage"
          :limit="4"
          :show-step-links="true"
          aria-controls
          first-number
          last-number
          v-show="pages"
        >
          <template #prev-text><span><b-icon icon="chevron-left" scale="1.5"></b-icon></span></template>
          <template #next-text><span><b-icon icon="chevron-right" scale="1.5"></b-icon></span></template>
        </b-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      fields: [
        { key: 'id', label: 'ID', tdClass: 'text-right' },
        { key: 'administrative_title', label: this.$i18n.t('administrative_title'), tdClass: 'text-left' },
        { key: 'property_category', label: this.$i18n.t('property_category') },
        { key: 'page_status', label: this.$i18n.t('label_page-status'), formatter: value => this.$i18n.t(value) },
        { key: 'report_status', label: this.$i18n.t(this.propertyType === 'business' ? 'label_sales-status' : 'label_rental-status'), formatter: value => this.$i18n.t(value) },
        this.propertyType === 'business' ? { key: 'property', label: this.$i18n.t('label_movie-ai') } : null,
        { key: 'property_types' },
        { key: 'updated_at', label: this.$i18n.t('label_last-updated-at'), formatter: value => value.substring(0, 10).replace(/-/g, '/') }
      ].filter(v => v),
      perPage: 30,
      currentPage: 1,
      filter: {
        name: null,
        status: null
      }
    }
  },
  computed: {
    filteredProperty: function () {
      return this.properties.data
        .filter(this.searchByName)
        .filter(this.filterByPageStatus)
    },
    draftCount: function () {
      return this.properties.data.filter((property) => {
        return (property.page_status === 'draft')
      })
    },
    publishedCount: function () {
      return this.properties.data.filter((property) => {
        return (property.page_status === 'published')
      })
    },
    pages: function () {
      if (this.filteredProperty.length <= 30) {
        return false
      } else {
        return true
      }
    }
  },
  props: {
    isForAdmin: {
      type: Boolean,
      default: true
    },
    propertyType: {
      type: String,
      required: true
    },
    properties: {
      type: Object,
      required: true
    },
    selectable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    locationDescriptor: function (propertyId, language = 'name_ja') {
      if (this.isForAdmin) {
        return {
          name: 'Edit Property Information',
          params: {
            type: this.propertyType,
            id: propertyId,
            language: language
          }
        }
      } else {
        return {
          name: 'business-property-edit',
          params: {
            id: propertyId
          }
        }
      }
    },
    buttonState: function () {
      if (this.selected.length === 0) {
        return true
      } else {
        return false
      }
    },
    searchByName: function (property) {
      if (this.filter.name === null || this.filter.name === '') {
        return true
      }
      return (property.administrative_title.toLowerCase().indexOf(this.filter.name.toLowerCase()) >= 0) || property.id.toString() === this.filter.name
    },
    filterByPageStatus: function (property) {
      if (this.filter.status === null) {
        return true
      }
      return (property.page_status === this.filter.status)
    },
    onRowSelected (items) {
      if (!this.selectable) return

      this.$router.push(this.locationDescriptor(items[0].id))
    }
  }
}
</script>
